module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    class: _vm.alingButton,
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.attr.disableField
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.callBusinessRule()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d85afc94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderButtonPDF.vue
// module id = 965
// module chunks = 2